<template>
  <div>
    <div class="row">
      <div
        v-if="actions"
        class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center pb-0 pt-0"
      >
        <h6>OUTROS DOCUMENTOS</h6>
      </div>
      <div
        v-if="actions"
        class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center justify-content-end pb-0 pt-0"
      >
        <v-btn
          v-if="permission('write', 'resident_documents')"
          class="btn-add mb-1"
          v-on:click="handleModalCreateDocument"
        >
          <i class="fas fa-arrow-down mr-2 text-twenty"></i> ADICIONAR À LISTA
        </v-btn>
      </div>
    </div>
    <b-modal
      no-close-on-backdrop
      size="md"
      id="createDocument"
      hide-footer
      title="NOVO DOCUMENTO"
    >
      <form v-on:submit="createDocument" method="post">
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <LabelRequiredField label="Nome do documento" />
            <input type="text" v-model="document_name" class="form-control" />
            <LabelRequiredField label="Documento" class="mt-3" />
            <input type="file" ref="document" class="form-control-file" />
            <p class="mb-0 mt-3 text-info-img">
              Tamanho máximo <strong>10MB</strong>
            </p>
            <p class="text-info-img">
              Formatos: <strong>PDF, JPG, JPEG, PJPEG</strong> e
              <strong>PNG</strong>
            </p>
            <LabelRequiredField
              label="Informe os perfis que terão acesso ao documento"
            />
            <vs-select
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pl-0 pr-0"
              placeholder="Perfis..."
              multiple
              autocomplete
              v-model="profilesSelected"
            >
              <vs-select-item
                v-for="item in profiles"
                :key="item.id"
                :text="item.text"
                :value="item.value"
                v-show="item.text != 'MASTER'"
              />
            </vs-select>
            <WarningRequiredFields />
            <ErrorsMessages :errors="errors" />
          </div>
          <div
            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right"
          >
            <v-btn
              :disabled="loadingCreateDocument"
              type="submit"
              class="btn-add"
            >
              <i class="fas fa-plus mr-2 text-twenty"></i>
              {{ loadingCreateDocument ? "Carregando" : "ADICIONAR" }}
            </v-btn>
          </div>
        </div>
      </form>
    </b-modal>
    <div
      v-if="actions"
      class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 pl-0 pb-0 pt-1"
    >
      <v-text-field
        v-model="searchDocuments"
        prepend-inner-icon="mdi-magnify"
        label="Pesquisar outros documentos"
        outlined
        dense
      />
    </div>
    <div
      v-if="actions"
      class="v-clean p-5 text-center col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
      v-show="documents.length == 0"
    >
      <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
    </div>
    <v-data-table
      v-show="documents.length > 0 && permission('read', 'resident_documents')"
      dense
      :headers="[
        { text: 'NOME DO DOCUMENTO', value: 'name', sortable: false },
        { text: 'AÇÕES', value: 'actions', sortable: false },
      ]"
      :items="documents"
      :search="searchDocuments"
      :footer-props="{
        'items-per-page-options': [50, 75, 100],
        'items-per-page-text': 'Mostrar',
      }"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          v-if="actions && permission('edit', 'resident_documents')"
          small
          class="btn-edit m-1"
          v-on:click="handleModalDocument(item)"
          @click="$bvModal.show(`document_edit_${item.id}`)"
        >
          <i class="fas fa-pencil-alt mr-2 text-twenty"></i> EDITAR
        </v-btn>
        <b-modal
          no-close-on-backdrop
          :id="`document_edit_${item.id}`"
          :title="`EDITAR DOCUMENTO: ${item.name}`"
          hide-footer
        >
          <form v-on:submit="updateDocument" method="post">
            <div class="col-md-12">
              <LabelRequiredField label="Nome do documento" />
              <input
                type="text"
                v-model="put_document_name"
                class="form-control"
              />
            </div>
            <div class="col-md-12">
              <LabelRequiredField label="Perfis que tem acesso" />
              <vs-select
                class="col-md-12 p-0"
                placeholder="Perfis..."
                multiple
                autocomplete
                v-model="put_profilesSelected"
              >
                <vs-select-item
                  v-for="item in profiles"
                  :key="item.id"
                  :text="item.text"
                  :value="item.value"
                  v-show="item.text != 'MASTER'"
                />
              </vs-select>
            </div>
            <div class="col-md-12 pt-0">
              <WarningRequiredFields />
              <ErrorsMessages :errors="errors" />
            </div>
            <div class="col-md-12">
              <confirmation-dialog
                v-if="permission('remove', 'resident_documents')"
                message-title="EXCLUIR?"
                message-body="Deseja realmente excluir o documento?"
                open-class="btn-delete"
                open-left-icon="fa-trash"
                open-text="EXCLUIR"
                @yes="deleteDocument(item)"
              />
              <v-btn
                :disabled="loadingUpdateDocument"
                type="submit"
                class="btn-save float-right"
              >
                <i class="fas fa-save mr-2 text-twenty"></i>
                {{ loadingUpdateDocument ? "Carregando" : "SALVAR" }}
              </v-btn>
            </div>
          </form>
        </b-modal>
        <v-btn
          v-show="item.doc_type == 'application/pdf'"
          small
          @click="openDocument('VIEW_PDF', item)"
          class="btn-annotation m-1"
        >
          <i class="fas fa-external-link-alt mr-1"></i> ABRIR PDF
        </v-btn>
        <v-btn
          v-show="item.doc_type != 'application/pdf'"
          small
          class="btn-annotation m-1"
          @click="openDocument('VIEW_IMG', item)"
        >
          <i class="fas fa-eye mr-1"></i> VISUALIZAR
        </v-btn>
        <b-modal
          no-close-on-backdrop
          :id="`document_${item.id}`"
          :title="item.name"
          hide-footer
        >
          <div class="d-flex flex-column align-items-center">
            <img :src="item.doc_url" :alt="item.name" class="document-img" />
            <v-btn
              class="btn-annotation mt-2"
              @click="openDocument('DOWNLOAD_IMG', item)"
            >
              DOWNLOAD
            </v-btn>
          </div>
        </b-modal>
        <v-btn
          v-show="permission('read', 'resident_documents_log')"
          small
          class="btn-annotation m-1"
          @click="showLogs(item)"
        >
          <i class="fas fa-eye mr-1"></i> LOGS
        </v-btn>
        <b-modal
          size="lg"
          no-close-on-backdrop
          :id="`document_log_${item.id}`"
          :title="item.name"
          hide-footer
        >
          <Logs :resident_id="resident_id" :users="users" :document="item" />
        </b-modal>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { formatDate } from "../../lib/format";

import ErrorsMessages from "../Components/ErrorsMessages";
import WarningRequiredFields from "../Components/WarningRequiredFields";
import LabelRequiredField from "../Components/LabelRequiredField";
import ConfirmationDialog from "../Components/ConfirmationDialog";

import Logs from "./Document/logs";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

import permission from "../../lib/permission";

export default {
  name: "Document",

  components: {
    ErrorsMessages,
    WarningRequiredFields,
    LabelRequiredField,
    ConfirmationDialog,
    Logs,
  },

  props: {
    rest_home_id: [String, Number],
    resident_id: [String, Number],
    user_id: [String, Number],
    users: [Array],
    actions: { type: Boolean, default: true },
  },

  data() {
    return {
      searchDocuments: "",
      documents: [],
      put_profilesSelected: [],
      profilesSelected: [],
      profiles: [],
      loadingUpdateDocument: false,
      loadingCreateDocument: false,
      document_id: "",
      put_document_name: "",
      document_name: "",
      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatDate,
    permission,

    showLogs(item) {
      this.$bvModal.show(`document_log_${item.id}`);
    },

    openDocument(type, item) {
      if (type == "VIEW_IMG") {
        this.createLog(item.id, "VIEW_IMG");
        this.$bvModal.show(`document_${item.id}`);
      } else if (type == "DOWNLOAD_IMG") {
        this.createLog(item.id, "DOWNLOAD_IMG");
        window.open(item.doc_url, "_blank");
      } else if (type == "VIEW_PDF") {
        this.createLog(item.id, "VIEW_PDF");
        window.open(item.doc_url, "_blank");
      }
    },

    async createLog(id, action) {
      try {
        const { resident_id } = this;

        let params = { resident_id, id, action };

        await api.post("/rest-home/history/document", params);
      } catch (error) {
        console.log(error);
      }
    },

    async retrieve() {
      let { actions } = this;

      if (this.errors.length == 0) await this.getDocuments();

      if (actions) {
        if (this.errors.length == 0) await this.getUserProfiles();
      }
    },

    async getDocuments() {
      try {
        const { resident_id } = this;

        const response = await api.get("/rest-home/resident/documents", {
          params: { resident_id },
        });

        const { error, errors, documents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.documents = documents;
          this.$emit("documents", documents);
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getUserProfiles() {
      try {
        const response = await api.get("/rest-home/profiles");

        const { error, errors, profiles } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          var array = [];

          for (let i = 0; i < profiles.length; i++) {
            var obj = {
              id: profiles[i].id,
              value: profiles[i].id,
              text: String(profiles[i].name).toUpperCase(),
            };

            array.push(obj);
          }

          this.profiles = array;
        }
      } catch (error) {
        console.log(error);
      }
    },

    handleModalCreateDocument() {
      this.document_name = "";
      this.profilesSelected = [];
      this.$bvModal.show("createDocument");
      this.errors = [];
    },

    async createDocument(event) {
      try {
        event.preventDefault();

        this.loadingCreateDocument = true;

        const {
          user_id,
          resident_id,
          profilesSelected,
          document_name,
          profiles,
        } = this;

        let master = profiles.find((profile) => profile.text == "MASTER");

        var document = this.$refs.document.files[0];

        var errors = [];

        if (!document_name) {
          errors.push({
            id: errors.length + 1,
            message: "Informe o nome do documento",
          });
        }

        if (!document) {
          errors.push({
            id: errors.length + 1,
            message: "Informe o documento",
          });
        }

        if (errors.length > 0) {
          this.errors = errors;

          this.loadingCreateDocument = false;
          return;
        }

        const allowedMimes = [
          "image/jpg",
          "image/jpeg",
          "image/pjpeg",
          "image/png",
          "application/pdf",
        ];

        if (!allowedMimes.includes(document.type)) {
          errors.push({
            id: errors.length + 1,
            message: "Formato de arquivo inválido",
          });
        }

        var limitSize = 10 * 1024 * 1024;

        if (document.size > limitSize) {
          errors.push({ id: errors.length + 1, message: "Suportado até 10MB" });
        }

        if (errors.length > 0) {
          this.errors = errors;

          this.loadingCreateDocument = false;
          return;
        }

        const formData = new FormData();

        for (let i = 0; i < profilesSelected.length; i++) {
          formData.append("user_profile_ids[]", profilesSelected[i]);
        }

        if (master) {
          formData.append("user_profile_ids[]", master.id);
        }

        formData.append("user_id", user_id);
        formData.append("resident_id", resident_id);
        formData.append("document_name", document_name);
        formData.append("document", document, document.name);
        formData.append("doc_type", document.type);

        const response = await api.post(
          "/rest-home/resident/document",
          formData
        );

        const { error, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.document_name = "";
          this.profilesSelected = [];
          this.getDocuments();
          this.$bvModal.hide("createDocument");
        } else {
          toast(message, "error");
        }

        this.loadingCreateDocument = false;
      } catch (error) {
        console.log(error);
      }
    },

    async handleModalDocument(document) {
      try {
        const { id, name } = document;

        this.document_id = id;
        this.errors = [];

        const response = await api.get("/rest-home/profiles/by-document", {
          params: { document_id: id },
        });

        const { error, errors, profiles } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          var array = [];

          for (let i = 0; i < profiles.length; i++) {
            if (profiles[i].name != "MASTER") {
              array[i] = profiles[i].id;
            }
          }

          this.put_document_name = name;
          this.put_profilesSelected = array;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async updateDocument(event) {
      try {
        event.preventDefault();

        this.loadingUpdateDocument = true;

        const {
          user_id,
          rest_home_id,
          resident_id,
          document_id,
          put_profilesSelected,
          put_document_name,
          profiles,
        } = this;

        var errors = [];

        let master = profiles.find((profile) => profile.text == "MASTER");

        if (!put_document_name) {
          errors.push({
            id: errors.length + 1,
            message: "Informe o nome do documento",
          });
        }

        if (errors.length > 0) {
          this.errors = errors;

          this.loadingUpdateDocument = false;
          return;
        }

        var user_profile_ids = [];

        if (master) {
          user_profile_ids.push(master.id);
        }

        for (let i = 0; i < put_profilesSelected.length; i++) {
          user_profile_ids.push(put_profilesSelected[i]);
        }

        let params = {
          user_id,
          resident_id,
          rest_home_id,
          document_id,
          document_name: put_document_name,
          user_profile_ids,
        };

        const response = await api.patch(
          "/rest-home/resident/document",
          params
        );

        const { error, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.put_document_name = "";
          this.put_profilesSelected = [];
          this.getDocuments();
          this.$bvModal.hide(`document_edit_${document_id}`);
        } else {
          toast(message, "error");
        }

        this.loadingUpdateDocument = false;
      } catch (error) {
        console.log(error);
      }
    },

    async deleteDocument(document) {
      try {
        const { id } = document;

        const { user_id } = this;

        let data = { user_id, id };

        const response = await api.delete("/rest-home/resident/document", {
          data,
        });

        const { error, message } = response.data;

        if (!error) {
          this.$bvModal.hide(`document_${id}`);
          toast(message, "success");
          this.getDocuments();
          this.stepResident = 2;
        } else {
          toast(message, "error");
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
.document-img {
  width: 100% !important;
  height: 450px !important;
  object-fit: contain !important;
}
</style>